import LanguageSelector from './component';

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/incab/common/LanguageSelector/index.js